export interface SyncCollectionItem {
    collection:    string;
    key:           string;
    name:          string;
    sub?:          boolean;
    url:           string;
    needsFeature?: string;
}

export const SyncCollections: SyncCollectionItem[] = [
    {
        collection: 'lockingSystemZones',
        key:        'lockingSystemZones',
        name:       'locking-system-zones.title_list',
        url:        'locking-system-zones',
    },
    {
        collection: 'people',
        key:        'people',
        name:       'people.title_list',
        url:        'people',
    },
    {
        collection: 'lockingSystemPermissions',
        key:        'lockingSystemPermissions',
        name:       'locking-system-permissions.title_list',
        url:        'locking-system-permissions',
    },
    {
        collection:   'timeLimits',
        key:          'timeLimits',
        name:         'time-limits.title_list',
        sub:          false,
        url:          'time-limits',
        needsFeature: 'HAS_TIME_LIMITS',
    },
    {
        collection: 'keys',
        key:        'keys',
        name:       'keys.title_list',
        url:        'keys-in-use',
    },
    {
        collection:   'keyPhones',
        key:          'keyPhones',
        name:         'keyPhones.title_list',
        sub:          true,
        url:          'keys-in-use',
        needsFeature: 'CAN_HAVE_PHONE_KEYS',
    },
    {
        collection:   'blocklistKeys',
        key:          'blocklistKeys',
        name:         'keys.keyGroup.blocklist.title_list',
        sub:          true,
        url:          'blocklist-keys',
        needsFeature: 'HAS_KEY_BLOCKLIST',
    },
    {
        collection: 'keyLockingSystemPermission',
        key:        'keyLockingSystemPermissions',
        name:       'locking-system-permissions.permissions_for_keys',
        sub:        true,
        url:        'locking-system-permissions',
    },
    {
        collection:   'keyTimeLimits',
        key:          'keyTimeLimits',
        name:         'time-limits.time_limits_for_keys',
        sub:          true,
        url:          'time-limits',
        needsFeature: 'HAS_TIME_LIMITS',
    },
    {
        collection:   'keyLockingSystemZone',
        key:          'keyLockingSystemZones',
        name:         'locking-system-zones.zones_for_keys',
        sub:          true,
        url:          'locking-system-zones',
        needsFeature: 'HAS_LOCKING_SYSTEM_ZONES',
    },
    {
        collection: 'locks',
        key:        'locks',
        name:       'locks.title_list',
        url:        'locks',
    },
    {
        collection: 'lockLockingSystemPermission',
        key:        'lockLockingSystemPermissions',
        name:       'locking-system-permissions.permissions_for_locks',
        sub:        true,
        url:        'locking-system-permissions',
    },
    {
        collection:   'lockTimeLimits',
        key:          'lockTimeLimits',
        name:         'time-limits.time_limits_for_locks',
        sub:          true,
        url:          'time-limits',
        needsFeature: 'HAS_TIME_LIMITS',
    },
]